import Vue from 'vue';
import { getDataBase } from '@/db';
import storeXD from '@/store/index';
import GeneracionLecturaController from '@/controllers/GeneracionLecturaController';
import FacturaController from '@/controllers/FacturaController';
import PaqueteTodoFacilController from '@/controllers/PaqueteTodoFacilController';
import FechaHora from '@/utils/FechaHora';
import LecturaNoSubidaDAL from '@/DAL/LecturaNoSubidaDAL';

import GeneracionLecturaFotoDAL from './DAL/GeneracionLecturaFotoDAL';
import GeneracionFacturaDAL from './DAL/GeneracionFacturaDAL';
import GeneracionLecturaDAL from './DAL/GeneracionLecturaDAL';




// Método para buscar clientes por Zona y ruta
export const getClientesByZonaRuta = async (tcZonaRuta) => {
  try {

    const db = await getDataBase();
    const tx = db.transaction('GENERACIONLECTURA', 'readonly');
    const store = tx.objectStore('GENERACIONLECTURA');
    const index = store.index('ZonaRuta');
    const clientes = await index.getAll(tcZonaRuta);
    await tx.done;
    return clientes;
  } catch (error) {
    console.error('Error al buscar clientes por Zona y Ruta:', error);
    return [];
  }
};



//metodo para buscar por zona en la tabla zona
export const getZonaByGeneracionFactura = async (generacionFactura) => {
  try {
    const db = await getDataBase();
    const tx = db.transaction('GENERACIONFACTURA', 'readonly');
    const store = tx.objectStore('GENERACIONFACTURA');
    const zona = await store.get(Number(generacionFactura));
    await tx.done;
    return zona;
  } catch (error) {
    console.error('Error al buscar zona por GeneracionFactura:', error);
    return {};
  }
}


//m,etodo para bnucar un cliente en la tabla clientes
export const getClienteByCliente = async (cliente) => {
  try {
    const db = await getDataBase();
    const tx = db.transaction('GENERACIONLECTURA', 'readonly');
    const store = tx.objectStore('GENERACIONLECTURA');
    const clienteData = await store.get(Number(cliente));
    await tx.done;
    return clienteData;
  } catch (error) {
    console.error('Error al buscar cliente por Cliente:', error);
    return {};
  }
}


//traer toda las lista de anormalidades
export const getAllAnormalidades = async () => {
  try {
    const db = await getDataBase();
    const tx = db.transaction('MEDIDORANORMALIDAD', 'readonly');
    const store = tx.objectStore('MEDIDORANORMALIDAD');
    const anormalidades = await store.getAll();
    await tx.done;
    return anormalidades;
  } catch (error) {
    console.error('Error al obtener anormalidades:', error);
    return [];
  }
}


// ----------------- cargar lecturas no subidas -----------------
export const addLecturaPendiente = async (toDatos) => {
  try {

    const loFecha = new FechaHora();

    const loDatosRequets = JSON.parse(JSON.stringify(toDatos.GeneracionLectura));
    loDatosRequets.tnEstado = 0;
    loDatosRequets.tcFecha = loFecha.getFecha();
    loDatosRequets.tcHora = loFecha.getHora();
    console.log('loDatosRequets:', loDatosRequets);

    const loGeneracionLectura = new GeneracionLecturaController();
    const loResult = await loGeneracionLectura.DO_LecturarNormal(toDatos);

    if (loResult.error == 1) {
      return loResult;
    }

    if (loResult.values.Error == 9999) {
      console.log('Error values.Error == 9999:', loResult.message);
      // storeXD.dispatch('triggerNotificationMessage', { message: loResult.message });
      return loResult;
    }


    await GeneracionFacturaDAL.incrementarLecturadosZona(loDatosRequets.tnGeneracionFactura);
    await GeneracionLecturaDAL.actualizarEstadoLectura(loDatosRequets.tnCliente);

    const db = await getDataBase();
    // Transacción para agregar lectura no subida
    const tx = db.transaction('lecturas_no_subidas', 'readwrite');
    const store = tx.objectStore('lecturas_no_subidas');
    await store.put(loDatosRequets);
    await tx.done;
    // storeXD.dispatch('triggerNotificationMessage', { message: 'Lectura offline guardada con exito', timeout: 3000 });

    return loResult;

  } catch (error) {
    console.error('Error al agregar lectura pendiente:', error);
    // storeXD.dispatch('triggerNotificationMessage', { message: 'Error al guardar lectura offline' });
    return { error: 1, message: 'Falló la operación de guardar datos offline.' };
  }
};


//-- imprimri factura -- //
export const CrearFactura = async (toDatos) => {

  try {
    const FacturaCC = new FacturaController();
    return await FacturaCC.CrearFactura(toDatos);
  } catch (error) {
    const loPaquete = new PaqueteTodoFacilController();
    const lcMensaje = error.message ? error.message : 'Error al crear factura';
    loPaquete.error = 1;
    loPaquete.status = 0;
    loPaquete.message = "Ups! Algo salio mal....\n Vuelva a intentarlo, si el problema persiste contacte a soporte";
    loPaquete.messageSistema = lcMensaje;
    return loPaquete;
  }
}

export const VerificarLecturasPorSubir = async () => {

  try {

    let lecturaNoSubidaDal = new LecturaNoSubidaDAL();
    let laLecturas = await lecturaNoSubidaDal.GetAllNoSubido();

    const lnCantidad = laLecturas.length;

    //notifcar que tiene leutra por subri 
    if (lnCantidad > 0) {
      storeXD.dispatch('triggerNotification', {
        message: `Tiene ${lnCantidad} Lecturas pendientes por subir`,
        type: 0,
        color: 'primary',
      });

    } else {
      storeXD.dispatch('triggerNotification', {
        message: 'Conectado a internet',
        // type: 0,
        color: 'primary',
        timeout: 3000
      });
    }
    return 0;
  } catch (error) {
    console.error(error);

    return 1;
  }
}


export const subirLecturaJson = async () => {
  console.log('====>SUBIDANO SUBINAIDO ')
  try {
    const db = await getDataBase();
    const tx = db.transaction('lecturas_no_subidas', 'readonly');
    const store = tx.objectStore('lecturas_no_subidas');
    let allRequests = await store.getAll();
    await tx.done;

    // Filtra solo los que tienen tnEstado igual a 0 o 1
    allRequests = allRequests.filter(item => item.tnEstado == 0 || item.tnEstado == 1 || item.tnEstado == 3);
    //converiotri a json 
    const loRequest = JSON.stringify(allRequests);


    //traer las tablas





  } catch (error) {
    console.error('Error en el CATH PRINCIPAL:', error);
    //ERRRO PRINCIPAL, SE DETIENE POR COMLETO LA SUBIDA DE LECTURAS


  }
};






export const subirLecturaPendiente = async (tnEstado) => {

  const loPaquete = new PaqueteTodoFacilController();
  let tnClienteAux = 0;
  try {

    storeXD.dispatch('triggerNotification', {
      message: `Subiendo Lecturas... `,
      type: 1
    });
    const db = await getDataBase();
    let allRequests = await LecturaNoSubidaDAL.GetAll2();

    switch (tnEstado) {
      case '0':
        allRequests = allRequests.filter(item => item.tnEstado == 0);
        break;
      case '1':
        allRequests = allRequests.filter(item => item.tnEstado == 1);
        break;
      case '3':
        allRequests = allRequests.filter(item => item.tnEstado == 3);
        break
      default:
        allRequests = allRequests.filter(item => item.tnEstado == 0 || item.tnEstado == 1 || item.tnEstado == 3);
        allRequests.sort((a, b) => {
          const fechaHoraA = `${a.tcFecha} ${a.tcHora}`; 
          const fechaHoraB = `${b.tcFecha} ${b.tcHora}`; 

          if (fechaHoraB > fechaHoraA) {
            return 1; 
          }
          if (fechaHoraB < fechaHoraA) {
            return -1; 
          }
          return 0; 
        });
        break;
    }

    const lnCantidadRequest = allRequests.length.toString();
    let lnIndice = 1;
    for (const request of allRequests) {

      await new Promise(resolve => setTimeout(resolve, 1000));

      storeXD.dispatch('triggerNotification', {
        message: `Subiendo Lecturas   ${lnIndice.toString()} de ${lnCantidadRequest}`,
        type: 1
      });
      lnIndice++;

      //cambiar el estado a 1, subiendo lectura
      await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 1 });
      tnClienteAux = request.tnCliente;

      //buscar imagnees de este cliente 
      let imagenesCliente = await GeneracionLecturaFotoDAL.getOnly(request.tnCliente);

      let formData = new FormData();
      // Agrega todos los atributos de 'request' al FormData
      for (let key in request) {
        if (request.hasOwnProperty(key)) {
          formData.append(key, request[key]);
        }
      }

      for (let imagen of imagenesCliente) {
        formData.append(`imageEnviar[]`, imagen.imageFile);  // Asegúrate de que el nombre coincida con lo que espera el backend
      }

      try {

        //verficar todas los campos del formualrio 

        const res = await Vue.prototype.$http.post('/admin/DO_LecturarNormal', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        //podriamos reintentar hasta 3 veces, eseperar un segundo...
        if (res.status < 200 || res.status >= 300) {
          throw new Error('Error de conexión: No se pudo establecer comunicación con el servidor. Inténtelo nuevamente.');
        }

        console.log('res:', res.data);

        //verifcar si hay algun error
        if (res.data.error == 1 || res.data.values.Error != 2000) {
          console.error('error == 1 al subir lectura pendiente en el metodo subirLecturaPendientes :', res.data);

          storeXD.dispatch('triggerNotification', {
            message: `Ups! Algo salio mal... Cliente:  ${request.tnCliente}`,
            timeout: 3000,
            color: 'danger',
            type: 0
          });

          await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 3 });

          const lecturaTx5 = db.transaction('lecturas_no_subidas', 'readwrite');
          const lecturaStore5 = lecturaTx5.objectStore('lecturas_no_subidas');
          const loLectura5 = await lecturaStore5.get([request.tnCliente, request.tnGeneracionFactura]);
          loLectura5.tnEstado = 3;
          await lecturaStore5.put(loLectura5);
          await lecturaTx5.done;
          await new Promise(resolve => setTimeout(resolve, 1000));
          continue;
        }


        //SOLO CAMBIAR DE ESTADO A 2, SUBIDO
        const lecturaTx = db.transaction('lecturas_no_subidas', 'readwrite');
        const lecturaStore = lecturaTx.objectStore('lecturas_no_subidas');
        const loLectura = await lecturaStore.get([request.tnCliente, request.tnGeneracionFactura]);
        loLectura.tnEstado = 2;
        await lecturaStore.put(loLectura);
        await lecturaTx.done;

        await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 2 });

      } catch (error) {
        console.error('ERROR CATH DO_LecturarNormal: ', error);
        await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 3 });

        storeXD.dispatch('triggerNotification', {
          message: `Ups! Algo salio mal... Cliente:  ${request.tnCliente}`,
          timeout: 3000,
          color: 'danger',
          type: 0
        });

        // poner el estado en 3// error
        let lecturaTx = db.transaction('lecturas_no_subidas', 'readwrite');
        let lecturaStore = lecturaTx.objectStore('lecturas_no_subidas');
        let loLectura = await lecturaStore.get([request.tnCliente, request.tnGeneracionFactura]);

        loLectura.tnEstado = 3;
        await lecturaStore.put(loLectura);
        await lecturaTx.done;

        //verificar cuantas lecturas quedan por subir si es que se genero error
        await VerificarLecturasPorSubir();

        loPaquete.error = 1;
        loPaquete.status = 0;
        loPaquete.message = 'ERROR CATH DO_LecturarNormal: ';
        loPaquete.messageSistema = error.message;
        return loPaquete;
      }
    } //END FOREACH


    storeXD.dispatch('triggerNotification', {
      message: 'Lecturas subidas a la nube con exito',
      timeout: 10000,
      color: 'success',
      type: 0
    });
    await VerificarLecturasPorSubir();


    return loPaquete;

  } catch (error) {
    console.error('Error en el CATH PRINCIPAL:', error);
    //ERRRO PRINCIPAL, SE DETIENE POR COMLETO LA SUBIDA DE LECTURAS
    loPaquete.error = 1;
    loPaquete.status = 0;
    loPaquete.message = 'ERROR ENTRAMOS AL CATH PRINCIPAL';
    loPaquete.messageSistema = error.message;
    return loPaquete;


  }
};





export const subirLecturaPendiente2 = async (tnEstado) => {
  const loPaquete = new PaqueteTodoFacilController();
  let tnClienteAux = 0;
  try {
    storeXD.dispatch('triggerNotification', {
      message: `Subiendo Lecturas... `,
      type: 1,
    });
    const db = await getDataBase();
    let allRequests = await LecturaNoSubidaDAL.GetAll2();

    // Filtrar según el estado
    switch (tnEstado) {
      case '0':
        allRequests = allRequests.filter((item) => item.tnEstado == 0);
        break;
      case '1':
        allRequests = allRequests.filter((item) => item.tnEstado == 1);
        break;
      case '3':
        allRequests = allRequests.filter((item) => item.tnEstado == 3);
        break;
      default:
        allRequests = allRequests.filter(
          (item) => item.tnEstado == 0 || item.tnEstado == 1 || item.tnEstado == 3
        );
        break;
    }

    const lnCantidadRequest = allRequests.length.toString();
    let lnIndice = 1;

    // Lote de 50 registros
    const batchSize = 5;
    let promises = [];

    for (let i = 0; i < allRequests.length; i += batchSize) {
      const batch = allRequests.slice(i, i + batchSize);
      await new Promise(resolve => setTimeout(resolve, 2000));
      const batchPromise = batch.map(async (request) => {
        // await new Promise((resolve) => setTimeout(resolve, 1000));

        storeXD.dispatch('triggerNotification', {
          message: `Subiendo Lecturas ${lnIndice.toString()} de ${lnCantidadRequest}`,
          type: 1,
        });
        lnIndice++;

        // Cambiar el estado a 1, subiendo lectura
        await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 1 });
        tnClienteAux = request.tnCliente;

        // Buscar imágenes de este cliente
        let imagenesCliente = await GeneracionLecturaFotoDAL.getOnly(request.tnCliente);

        let formData = new FormData();
        // Agrega todos los atributos de 'request' al FormData
        for (let key in request) {
          if (request.hasOwnProperty(key)) {
            formData.append(key, request[key]);
          }
        }

        for (let imagen of imagenesCliente) {
          formData.append(`imageEnviar[]`, imagen.imageFile);
        }

        try {
          // Verificar todos los campos del formulario
          const res = await Vue.prototype.$http.post('/admin/DO_LecturarNormal', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          // Verificación de éxito
          if (res.status < 200 || res.status >= 300) {
            throw new Error('Error de conexión: No se pudo establecer comunicación con el servidor. Inténtelo nuevamente.');
          }

          console.log('res:', res.data);

          // Verificar si hay algún error
          if (res.data.error == 1 || res.data.values.Error != 2000) {
            console.error('error al subir lectura pendiente:', res.data);

            storeXD.dispatch('triggerNotification', {
              message: `Ups! Algo salio mal... Cliente:  ${request.tnCliente}`,
              timeout: 3000,
              color: 'danger',
              type: 0,
            });

            await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 3 });

            const lecturaTx5 = db.transaction('lecturas_no_subidas', 'readwrite');
            const lecturaStore5 = lecturaTx5.objectStore('lecturas_no_subidas');
            const loLectura5 = await lecturaStore5.get(request.tnCliente);
            loLectura5.tnEstado = 3;
            await lecturaStore5.put(loLectura5);
            await lecturaTx5.done;

            // await new Promise((resolve) => setTimeout(resolve, 1000));
            return; // Detener el proceso para este lote
          }

          // Cambiar el estado a 2, subido
          const lecturaTx = db.transaction('lecturas_no_subidas', 'readwrite');
          const lecturaStore = lecturaTx.objectStore('lecturas_no_subidas');
          const loLectura = await lecturaStore.get(request.tnCliente);
          loLectura.tnEstado = 2;
          await lecturaStore.put(loLectura);
          await lecturaTx.done;

          await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 2 });
        } catch (error) {
          console.error('ERROR CATH DO_LecturarNormal: ', error);

          await storeXD.dispatch('triggerLecturaPendiente', { cliente: request.tnCliente, estado: 3 });

          storeXD.dispatch('triggerNotification', {
            message: `Ups! Algo salio mal... Cliente:  ${request.tnCliente}`,
            timeout: 3000,
            color: 'danger',
            type: 0,
          });

          // Poner el estado en 3 // error
          let lecturaTx = db.transaction('lecturas_no_subidas', 'readwrite');
          let lecturaStore = lecturaTx.objectStore('lecturas_no_subidas');
          let loLectura = await lecturaStore.get(request.tnCliente);
          loLectura.tnEstado = 3;
          await lecturaStore.put(loLectura);
          await lecturaTx.done;

          // Verificar cuántas lecturas quedan por subir si es que se generó error
          await VerificarLecturasPorSubir();
        }
      });

      // Agregar todas las promesas del lote
      promises.push(Promise.allSettled(batchPromise));
    }

    // Esperar a que todos los lotes se resuelvan
    const results = await Promise.allSettled(promises);

    // Manejar los resultados de todas las promesas
    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        console.log(`Lote ${index + 1} subido con éxito.`);
      } else {
        console.error(`Error en el lote ${index + 1}:`, result.reason);
      }
    });

    storeXD.dispatch('triggerNotification', {
      message: 'Lecturas subidas a la nube con éxito',
      timeout: 10000,
      color: 'success',
      type: 0,
    });

    await VerificarLecturasPorSubir();

    return loPaquete;
  } catch (error) {
    console.error('Error en el CATH PRINCIPAL:', error);
    loPaquete.error = 1;
    loPaquete.status = 0;
    loPaquete.message = 'ERROR ENTRAMOS AL CATH PRINCIPAL';
    loPaquete.messageSistema = error.message;
    return loPaquete;
  }
};




// PARAMETRO LECTURACION
export const getParametroLectura = async () => {
  try {

    const db = await getDataBase();
    const tx = db.transaction('PARAMETROLECTURA', 'readonly');
    const store = tx.objectStore('PARAMETROLECTURA');
    const loData = await store.getAll(1);
    await tx.done;
    return loData;
  } catch (error) {
    console.error('Error al buscar cliente por Cliente:', error);
    return [];
  }
}



//--- MOSTAR LISTA DE LECUTRA PENDIENTES EN OFFLINE
export const getLecturasPendientesOffline = async () => {
  try {
    const db = await getDataBase();
    const tx = db.transaction('lecturas_no_subidas', 'readonly');
    const store = tx.objectStore('lecturas_no_subidas');
    let lecturasPendientes = await store.getAll();

    // Ordenamos por fecha y hora (la fecha más cercana se muestra primero)
    lecturasPendientes.sort((a, b) => {
      // Combina la fecha y la hora en un solo string y conviértelo en un objeto Date
      const fechaA = new Date(`${a.tcFecha}T${a.tcHora}`);
      const fechaB = new Date(`${b.tcFecha}T${b.tcHora}`);

      // Ordenar ascendentemente (la fecha más cercana primero)
      return fechaA - fechaB;
    });



    await tx.done;
    return lecturasPendientes;
  } catch (error) {
    console.error('Error al obtener lecturas pendientes:', error);
    return [];
  }
};


//--- MOSTAR LISTA DE LECUTRA PENDIENTES EN OFFLINE
export const limpiarCache = async () => {
  try {
    console.log('Limpiando datos del sitio...');

    // Obtener todas las bases de datos
    const dbs = await indexedDB.databases();

    // Usamos for...of para recorrer las bases de datos
    for (const db of dbs) {
      if (db.name === "lecturas-db") {
        // Abrir la base de datos "lecturas-db"
        const dbInstance = await abrirBaseDeDatos(db.name);

        if (dbInstance) {
          // Definir las tablas (almacenes de objetos) que NO queremos vaciar
          const tablasExcluidas = ["lecturas_no_subidas", "GENERACIONLECTURAFOTO", "MEDIDORANORMALIDAD", "LOGMOVIL"];

          // Usamos for...of para recorrer las tablas de la base de datos
          for (const storeName of dbInstance.objectStoreNames) {
            // Si la tabla no está en la lista de exclusiones, la vaciamos
            if (!tablasExcluidas.includes(storeName)) {
              try {
                await vaciarTabla(dbInstance, storeName);
                console.log(`La tabla ${storeName} ha sido vaciada.`);
              } catch (error) {
                console.error(`Error al vaciar la tabla ${storeName}:`, error);
              }
            }
          }

          // Cerrar la conexión a la base de datos cuando terminamos
          dbInstance.close();
        }
      }
    }

    // Limpiar localStorage
    localStorage.clear();

    // Limpiar SessionStorage
    sessionStorage.clear();

    console.log("Datos limpiados excepto el Service Worker y las tablas protegidas en lecturas-db.");

    // Recargar la página para aplicar los cambios
    window.location.reload();
  } catch (error) {
    console.error('Error al limpiar los datos del sitio:', error);
  }
};

// Función asíncrona para abrir una base de datos
const abrirBaseDeDatos = async (nombreDB) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(nombreDB);

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = function (event) {
      console.error(`Error al abrir la base de datos ${nombreDB}:`, event);
      reject(event);
    };
  });
};

// Función asíncrona para vaciar una tabla (almacén de objetos)
const vaciarTabla = async (dbInstance, storeName) => {
  return new Promise((resolve, reject) => {
    const transaction = dbInstance.transaction([storeName], "readwrite");
    const objectStore = transaction.objectStore(storeName);
    const clearRequest = objectStore.clear();

    clearRequest.onsuccess = function () {
      resolve();
    };

    clearRequest.onerror = function (event) {
      reject(event);
    };
  });
};








